import { render, staticRenderFns } from "./net_bar_order.vue?vue&type=template&id=5be4b972&scoped=true&"
import script from "./net_bar_order.vue?vue&type=script&lang=js&"
export * from "./net_bar_order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be4b972",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5be4b972')) {
      api.createRecord('5be4b972', component.options)
    } else {
      api.reload('5be4b972', component.options)
    }
    module.hot.accept("./net_bar_order.vue?vue&type=template&id=5be4b972&scoped=true&", function () {
      api.rerender('5be4b972', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/components/net_bar_order.vue"
export default component.exports